export const companyAEFields = {
  /* ================= COMPANY TAB ================= */

  companyName: {
    name: "company__company_name",
    label: "Company Name",
    required: true,
  },

  parentCompanyName: {
    name: "company__parent_company_name",
    label: "Parent Company Name",
    required: false,
  },

  dbaName: {
    name: "company__dba_name",
    label: "DBA Name",
    required: false,
  },

  naicsCode: {
    name: "company__naics_code",
    label: "NAICS Code",
    required: true,
  },

  federalTaxId: {
    name: "company__federal_tax_id",
    label: "Federal Tax ID",
    required: false,
  },

  carrierRouteId: {
    name: "company__carrier_route_id",
    label: "Carrier Route ID",
    required: false,
  },

  uspsMailerId: {
    name: "company__usps_mailer_id",
    label: "USPS Mailer ID",
    required: false,
  },

  customerRegistrationId: {
    name: "company__company_registration_id",
    label: "CR ID",
    required: false,
  },

  companyWebsite: {
    name: "company__company_website",
    label: "Company Website",
    required: false,
  },

  customerSinceDate: {
    name: "company__customer_since_date",
    label: "Customer Since Date",
    required: false,
  },

  isForeignLocation: {
    name: "is_foreign_location",
    label: "Foreign Location",
    required: true,
  },

  isNcoa: {
    name: "is_ncoa",
    label: "NCOALink Service",
    required: true,
  },

  isDsf: {
    name: "is_dsf",
    label: "DSF2 Service",
    required: true,
  },

  isTriplex: {
    name: "is_triplex",
    label: "Triplex",
    required: true,
  },

  isWaiverOnFile: {
    name: "is_waiver_on_file",
    label: "NCOALink 7-Day Fulfillment Waiver on File",
    required: true,
  },

  /* ================= ADDRESS TAB ================= */

  address1: {
    name: "company__address1",
    label: "Address 1",
    required: true,
  },
  address2: {
    name: "company__address2",
    label: "Address 2",
    required: false,
  },
  city: {
    name: "company__city",
    label: "City",
    required: true,
  },

  state: {
    name: "company__state",
    label: "State",
    required: true,
  },

  postalCode: {
    name: "company__postal_code",
    label: "Zip",
    required: true,
  },

  urbanization: {
    name: "company__urbanization",
    label: "Urbanization",
    required: false,
  },

  /* ================= CONTACT TAB ================= */

  representativeName: {
    name: "company__representative_name",
    label: "Representative Name",
    required: true,
  },

  representativeTitle: {
    name: "company__representative_title",
    label: "Representative Title",
    required: false,
  },

  representativeEmail: {
    name: "company__representative_email",
    label: "Representative Email",
    required: true,
  },

  phone: {
    name: "company__phone",
    label: "Telephone",
    required: true,
  },

  /* ================= FLAGS (HIDDEN / DEFAULTED) ================= */

  isDeleted: {
    name: "is_deleted",
    label: "Is Deleted",
    required: false,
  },

  customerIsDeleted: {
    name: "company__is_deleted",
    label: "Is Deleted",
    required: false,
  },

  customerIsInternal: {
    name: "company__is_internal",
    label: "Is Internal",
    required: false,
  },

} as const;

